import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { QuotesListTableDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import UpsertSidePanel from '../../components/Quotes/UpsertSidePanel'

const QuoteUpsertPage = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const dealId = state?.dealId
  const { navigation } = useNavigation()
  const { quoteId } = useParams()
  const { employee } = useCurrentSession()

  const defaultLegalEntity = employee?.legalEntity
  const defaultCurrency = defaultLegalEntity?.currency
  const defaultDate = moment().format('YYYY-MM-DD')

  const onClose = () => {
    if (!!dealId) {
      navigate(navigation.finance.sales.deals.dealId.quotes.fullPath({ dealId }))
    } else {
      navigate(navigation.finance.sales.quotes.fullPath())
    }
  }

  return (
    <ResponsivePage.Body variant="full">
      <UpsertSidePanel
        quoteId={quoteId}
        onClose={onClose}
        defaultCurrency={defaultCurrency}
        defaultDate={defaultDate}
        defaultLegalEntity={defaultLegalEntity}
        documentToRefetchOnCreate={QuotesListTableDocument}
        defaultDealId={dealId ? Number(dealId) : undefined}
      />
    </ResponsivePage.Body>
  )
}

export default QuoteUpsertPage
